import { useMutation } from '@tanstack/react-query';
import { toast } from '../../../lib/toast';
import { resendInvite } from '../api/users';

function extractErrorMessage(err: unknown): string {
  const axiosErr = err as { response?: { data?: { detail?: string; title?: string } } };
  return axiosErr.response?.data?.detail ?? axiosErr.response?.data?.title ?? 'Failed to send invite email';
}

export function useResendInvite(onSuccess?: () => void) {
  return useMutation({
    mutationFn: (userId: string) => resendInvite(userId),
    onSuccess: () => {
      toast.success('Invitation email sent');
      onSuccess?.();
    },
    onError: (err: unknown) => {
      toast.error(extractErrorMessage(err));
    },
  });
}
